import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../authmanagement/services/Auth.service";
import { SessionService } from "../shared/services/Session.service";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  isAuthenticated: boolean;
  private _IsAuthorized: boolean;

  constructor(private authService: AuthService, private router: Router, private sessionService: SessionService) {}

  ngOnInit(): void {    
  }

  async Logout() {
    let resp = await this.authService.Logout();
    console.log("logout");
  }
}
